import { render, staticRenderFns } from "./kategori-biaya.vue?vue&type=template&id=ee308afc&scoped=true&"
import script from "./kategori-biaya.vue?vue&type=script&lang=js&"
export * from "./kategori-biaya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee308afc",
  null
  
)

export default component.exports